import React from "react";
import { Tooltip } from "../../../components/Tooltip";

export const employerSpecificTooltipText =
    "Met de optie Bedrijfsspecifiek kun je onder de cursus aangeven of een " +
    "cursist een competentie zal uitvoeren die specifiek is voor het bedrijf of organisatie waar hij/zij werkt. Kies " +
    "je hiervoor dan zal hiervan melding worden gemaakt op de uiteindelijke certificering. Kies je er niet voor, dan " +
    "zal de cursist een certificaat ontvangen zonder deze aantekening.";

/**
 * Employer specific tooltip.
 * @param {string} [identifier] The identifier of the tooltip.
 * @param {*} props Additional props are passed to <Tooltip />
 * @returns {JSX.Element}
 */
export function EmployerSpecificTooltip({ identifier = "employer-specific", ...props }) {
    return <Tooltip identifier={identifier} {...props} tooltip={<p className={"paragraph"}>{employerSpecificTooltipText}</p>} />;
}

/**
 * Tooltip explaining the different course states.
 * @param {string} [identifier=course-state] The identifier of the tooltip.
 * @param {*} props Additional props are passed to <Tooltip />
 * @returns {JSX.Element}
 */
export function CourseStateTooltip({ identifier = "course-state", ...props }) {
    return (
        <Tooltip
            identifier={identifier}
            {...props}
            tooltip={
                <ul style={{ wordWrap: "break-word", overflow: "hidden", whiteSpace: "normal" }}>
                    <li>
                        <b>Open</b>: Cursus is gepland of bezig
                    </li>
                    <li>
                        <b>Afgelopen</b>: Datum en eindtijd van het laatste toetsmoment liggen in het verleden
                    </li>
                    <li>
                        <b>Afgerond</b>: Resultaten zijn ingestuurd door de instructeur(s)
                    </li>
                    <li>
                        <b>Geannuleerd</b>: Cursus is geannuleerd
                    </li>
                </ul>
            }
        />
    );
}

/**
 * Tooltip explaining the consequences of students not having an e-mail address.
 * @param {string} [intro] Optional intro text. Used to provide a more specific context
 * about the number of students.
 * @param {string} [identifier="missing-email"]
 * @param props Additional props are passed to <Tooltip />
 * @returns {JSX.Element}
 */
export function MissingEmailTooltip({ intro, identifier = "missing-email", ...props }) {
    return (
        <Tooltip
            identifier={identifier}
            {...props}
            tooltip={
                <>
                    {intro && <p className="paragraph">{intro}</p>}
                    <ul>
                        <li>De cursist ontvangt geen aanwijzingen over de cursus per e-mail</li>
                        <li>De cursist krijgt geen directe toegang tot Mijn NIBHV</li>
                        {/* #1609 - The credentials download is disabled */}
                        {/*<li>Je kunt de cursist wel voorzien van inloggegevens op basis van
                        NIBHV-nummer en een tijdelijk wachtwoord (kijk hiervoor onder downloads)</li>*/}
                    </ul>
                </>
            }
        />
    );
}

export function EmailRequiredToolTip({ identifier = "email-required", ELearning = false, ...props }) {
    return (
        <Tooltip
            identifier={identifier}
            {...props}
            tooltip={
                <p className="paragraph">
                    {ELearning
                        ? // note: Added a word joiner character in "E-mailadres" to ensure it doesn't wrap:
                          "Voor cursussen met E-learning is het verplicht om een E-⁠mailadres op te geven."
                        : "Het is verplicht om een E-mailadres op te geven."}
                </p>
            }
        />
    );
}

export function DontShowProgressAutomaticallyToolTip({ identifier = "dont-show-progress", ...props }) {
    return (
        <Tooltip
            identifier={identifier}
            {...props}
            tooltip={
                <p className="paragraph">
                    Met deze optie geef je aan of de voortgang van een cursist achtergehouden moet worden in Mijn NIBHV. Als dit gedeactiveerd is wordt de voortgang van
                    een cursist pas getoond in Mijn NIBHV na het afronden van de cursist op de cursus.
                </p>
            }
        />
    );
}

export function CourseUserActionTooltip({ identifier = "course-user-actions", mode, ...props }) {
    let tooltipText;

    if (mode === "cancel") {
        tooltipText =
            "Hiermee stelt u de cursist op de hoogte van zijn annulering. Laat u de schuiver uit? Dan wordt de cursist alleen geannuleerd en niet op de hoogte gesteld. ";
    } else if (mode === "delete") {
        tooltipText =
            "Hiermee stelt u de cursist op de hoogte van zijn verwijdering. Laat u de schuiver uit? Dan wordt de cursist alleen verwijderd en niet op de hoogte gesteld. ";
    } else if (mode === "uncancel") {
        tooltipText =
            "Hiermee stelt u de cursist op de hoogte van zijn heractivatie. Laat u de schuiver uit? Dan wordt de cursist alleen geheractiveerd en niet op de hoogte gesteld. ";
    }

    return <Tooltip identifier={identifier} {...props} tooltip={<p className="paragraph">{tooltipText}</p>} />;
}
